export default "__VITE_ASSET__3NzfygvX__"